import { useEffect, useMemo, useState } from "react";
import { Alert } from "reactstrap";

import { useUserRecordActivityUpdate } from "./SelectableReferences/useUpdateUserRecordActivity";
import ModuleFieldsPicker from "../../../TableLayouts/ModuleFieldsPicker";
import { Module } from "../../../../types/TenantInterfaces";
import IconButton from "../../../../elements/IconButton";

interface Props {
  module: Module;
  onClose: () => void;
}
/**
 *
 * Component to handle the field metadata that will be displayed in the AllReferences component.
 * This setting will be per module-user.
 *
 * The module has a default metadata field setting that will be used if the user doesn't have any metadata fields.
 */

function MetadataFieldSettings({ module, onClose }: Props) {
  const [selectedFields, setSelectedFields] = useState<string[]>([]);
  const [error, setError] = useState<{ message: string } | null>(null);
  const { updateUserModuleMetadata, userRecordActivity } =
    useUserRecordActivityUpdate();

  useEffect(() => {
    setSelectedFields(userRecordActivity?.[module?.APIName]?.Fields ?? []);
  }, [userRecordActivity?.[module?.APIName]]);

  const availableFields = useMemo(() => {
    return module?.Fields.filter((f) =>
      ["Email", "Phone", "URL", "Text"].includes(f.FieldType)
    );
  }, [module]);

  return (
    <>
      <div
        style={{
          minWidth: "280px",
          maxWidth: "380px",
          width: "90vw",
        }}
      >
        <div className="tw:border-b-1 tw:border-superlight">
          <div className="tw:flex tw:items-center tw:p-2">
            <IconButton
              icon="mdi mdi-chevron-left"
              size="sm"
              color="secondary"
              outline
              onClick={(e: any) => {
                e.stopPropagation();
                handleOnClose();
              }}
            />
            <h4 className="tw:m-0">Settings</h4>
          </div>
        </div>
      </div>
      <div className="tw:p-4">
        <div className="tw:font-medium tw:pb-2">
          Select a field to display as additional information.
        </div>
        <h3> Select Fields (limited to 2)</h3>
        {error && (
          <Alert color="warning" className="tw:p-2">
            {error.message}
          </Alert>
        )}
        <ModuleFieldsPicker
          module={module}
          layoutLimit={2}
          values={selectedFields}
          setValues={setSelectedFields}
          onChange={setSelectedFields}
          placeholder="Select Metadata Fields"
          disabled={false}
          availableFields={availableFields}
          setError={setError}
        />
      </div>
    </>
  );

  function handleOnClose() {
    onClose();
    updateUserModuleMetadata({
      fields: selectedFields,
      moduleAPIName: module?.APIName,
    });
  }
}

export default MetadataFieldSettings;
